import React, { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';
import classNames from 'clsx';

import {
  ALL_TYPES,
  TYPE_CHANNEL_VIEW_BOTTOM,
  TYPE_CHANNEL_VIEW_TOP,
  TYPE_MAIN_BOTTOM,
  TYPE_MAIN_TOP,
  TYPE_PLAYER_PAGE_BOTTOM,
  TYPE_PLAYER_PAGE_TOP,
  TYPE_SEARCH_BOTTOM,
  TYPE_SEARCH_SIDEBAR,
  TYPE_SEARCH_TOP,
} from '../../constants';
import { APP_BUILD_ENV } from '@/modules/common/constants/envs';
import {
  ALL_EXISTING_ROUTES,
  CHANNEL_LIST_PATH,
  CHANNEL_VIEW_PATH,
  DEFAULT_VIEW_PATH,
  SEARCH_AI_VIEW_PATH,
  SEARCH_PATH,
  SEARCH_VIEW_PATH,
  SHARE_VIEW_PATH,
  SINGLE_VIEW_PATH,
} from '@/modules/common/constants/routePath';

import styles from './Container.module.scss';

type Props = {
  id: (typeof ALL_TYPES)[number];
};

const mappingByType: Record<
  (typeof ALL_TYPES)[number],
  {
    className: string;
    visibleRoutes: typeof ALL_EXISTING_ROUTES;
  }
> = {
  [TYPE_MAIN_TOP]: {
    className: styles.Banner___top,
    visibleRoutes: [CHANNEL_LIST_PATH],
  },
  [TYPE_MAIN_BOTTOM]: {
    className: styles.Banner___bottom,
    visibleRoutes: [CHANNEL_LIST_PATH],
  },

  [TYPE_CHANNEL_VIEW_TOP]: {
    className: styles.Banner___top,
    visibleRoutes: [CHANNEL_VIEW_PATH],
  },
  [TYPE_CHANNEL_VIEW_BOTTOM]: {
    className: styles.Banner___bottom,
    visibleRoutes: [CHANNEL_VIEW_PATH],
  },

  [TYPE_SEARCH_TOP]: {
    className: styles.Banner___top,
    visibleRoutes: [SEARCH_PATH],
  },
  [TYPE_SEARCH_BOTTOM]: {
    className: styles.Banner___bottom,
    visibleRoutes: [SEARCH_PATH],
  },

  [TYPE_PLAYER_PAGE_TOP]: {
    className: styles.Banner___top,
    visibleRoutes: [SEARCH_VIEW_PATH, SEARCH_AI_VIEW_PATH, DEFAULT_VIEW_PATH, SHARE_VIEW_PATH, SINGLE_VIEW_PATH],
  },
  [TYPE_SEARCH_SIDEBAR]: {
    className: styles.Banner___sidebar,
    visibleRoutes: [SEARCH_VIEW_PATH, SEARCH_AI_VIEW_PATH, DEFAULT_VIEW_PATH, SHARE_VIEW_PATH, SINGLE_VIEW_PATH],
  },
  [TYPE_PLAYER_PAGE_BOTTOM]: {
    className: styles.Banner___bottom,
    visibleRoutes: [SEARCH_VIEW_PATH, SEARCH_AI_VIEW_PATH, DEFAULT_VIEW_PATH, SHARE_VIEW_PATH, SINGLE_VIEW_PATH],
  },
};

function Container({ id }: Props) {
  const location = useLocation();

  const [className, disabled] = useMemo(() => {
    const currentRoute = ALL_EXISTING_ROUTES.find((route) => matchPath(route, location.pathname));

    return [mappingByType[id].className, currentRoute && !mappingByType[id].visibleRoutes.includes(currentRoute)];
  }, [location.pathname, id]);

  return (
    <div
      className={classNames(
        styles.Banner,
        {
          [styles.Banner___plug]: ['dev-local', 'dev'].includes(APP_BUILD_ENV),
        },
        className,
      )}
      id={id}
      data-ad-loaded={undefined} // indicator for ad init detection
      data-ad-disabled={disabled ? '' : undefined} // indicator to detect disable state for ad init by route
    />
  );
}

export default Container;
